import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { TagWrapper } from './PartItemTag.styles';

interface PartItemTagProps {
  partIndex: number;
  partsTotal: number;
}

export const PartItemTag: React.FC<PartItemTagProps> = ({ partIndex, partsTotal }) => {
  const { t } = useTranslation('DefaultTranslations');

  if (typeof partIndex !== 'number' || typeof partsTotal !== 'number' || partsTotal <= 1) {
    return null;
  }

  return (
    <Tooltip title={t('PARTED_TASK_DATE_TOOLTIP', { partsTotal })}>
      <TagWrapper>{t('PARTED_TASK_DATE_FORMAT', { partIndex, partsTotal })}</TagWrapper>
    </Tooltip>
  );
};
